var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gantt-message-overlay",on:{"click":_vm.close}},[_c('div',{staticClass:"gantt-message-message",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }